import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, errMsg, fmtDate, money } from "@/lib/api";

const BLANK = { code: "", discountType: "percentage", discountValue: "", maxUses: "", expiresAt: "", isActive: true };

const toBody = (c) => ({
  code: c.code, discountType: c.discountType, discountValue: Number(c.discountValue), isActive: c.isActive,
  maxUses: c.maxUses === "" || c.maxUses === null ? null : Number(c.maxUses),
  expiresAt: c.expiresAt ? String(c.expiresAt).slice(0, 10) : null,
});

export const CouponsTab = () => {
  const [items, setItems] = useState([]);
  const [f, setF] = useState(BLANK);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const load = useCallback(() => api.get("/admin/coupons").then((r) => setItems(r.data)).catch(() => {}), []);
  useEffect(() => {
    load();
  }, [load]);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/coupons", toBody(f));
      toast.success("Coupon created");
      setF(BLANK);
      load();
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  const toggle = async (c, v) => {
    await api.put(`/admin/coupons/${c.id}`, toBody({ ...c, isActive: v })).catch((e) => toast.error(errMsg(e)));
    load();
  };
  const del = async (c) => {
    if (!window.confirm(`Delete coupon ${c.code}?`)) return;
    await api.delete(`/admin/coupons/${c.id}`);
    load();
  };

  return (
    <div className="space-y-6" data-testid="admin-coupons">
      <form onSubmit={create} className="grid grid-cols-2 gap-4 bg-[#FDFBF7] p-6 md:grid-cols-6">
        <label><span className="field-label mb-1">Code</span><input required className="admin-input uppercase" value={f.code} onChange={(e) => set("code", e.target.value.toUpperCase())} placeholder="WELCOME10" data-testid="coupon-code-input" /></label>
        <label><span className="field-label mb-1">Type</span>
          <select className="admin-input" value={f.discountType} onChange={(e) => set("discountType", e.target.value)} data-testid="coupon-type-select">
            <option value="percentage">Percentage %</option><option value="fixed">Fixed AUD</option>
          </select>
        </label>
        <label><span className="field-label mb-1">Value</span><input required type="number" step="any" min="0" className="admin-input" value={f.discountValue} onChange={(e) => set("discountValue", e.target.value)} data-testid="coupon-value-input" /></label>
        <label><span className="field-label mb-1">Max uses</span><input type="number" min="0" className="admin-input" value={f.maxUses} onChange={(e) => set("maxUses", e.target.value)} placeholder="Unlimited" data-testid="coupon-maxuses-input" /></label>
        <label><span className="field-label mb-1">Expires</span><input type="date" className="admin-input" value={f.expiresAt} onChange={(e) => set("expiresAt", e.target.value)} data-testid="coupon-expires-input" /></label>
        <div className="flex items-end"><button className="btn-primary w-full px-4 py-2.5" data-testid="coupon-add-btn">Create</button></div>
      </form>
      <div className="overflow-x-auto bg-[#FDFBF7] p-6">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#E5E0D8] text-left text-[10px] uppercase tracking-[0.2em] text-[#5A626A]">
              <th className="py-3">Code</th><th>Discount</th><th>Used</th><th>Expires</th><th>Active</th><th />
            </tr>
          </thead>
          <tbody>
            {items.length === 0 && <tr><td colSpan={6} className="py-6 text-[#8A8780]">No coupons yet</td></tr>}
            {items.map((c) => (
              <tr key={c.id} className="border-b border-[#F0EDE6]" data-testid={`coupon-row-${c.code}`}>
                <td className="py-3 font-medium tracking-wider">{c.code}</td>
                <td>{c.discountType === "percentage" ? `${c.discountValue}%` : money(c.discountValue)}</td>
                <td>{c.timesUsed}{c.maxUses ? ` / ${c.maxUses}` : ""}</td>
                <td>{fmtDate(c.expiresAt)}</td>
                <td><Switch checked={c.isActive} onCheckedChange={(v) => toggle(c, v)} data-testid={`coupon-active-toggle-${c.code}`} /></td>
                <td className="text-right"><button className="text-xs text-[#8B2E24] underline underline-offset-4" onClick={() => del(c)} data-testid={`coupon-delete-btn-${c.code}`}>Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
